import React from 'react';
import styled from 'styled-components';
import LogoWrapper from './LogoWrapper';
import InfoWrapper from './InfoWrapper';
import SiteMap from './SiteMap';

const FooterWrapper = styled.footer`
  width: 100%;
  font-family: 'SDGothicNeobTTF-bLt';
`;

const FooterContent = styled.div`
  position: relative;
  box-sizing: border-box;
  border-top: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.875rem 1.312rem;
`;

const ButtonArea = styled.div`
  position: relative;
  margin-top: 15px;
  margin-top: 0.9375rem;
  width: 100%;
  height: 40px;
  height: 2.5rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #79838d;
`;
const Button = styled.button`
  width: 100%;
  float: left;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  ::before {
    content: '　';
    position: absolute;
    font-size: 0;
  }
`;
const Txt = styled.span`
  font-size: 11px;
  font-size: 0.6875rem;
  color: #fff;
  line-height: 40px;
  line-height: 2.5rem;
  vertical-align: 3px;
`;
const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContent>
        <LogoWrapper />
        <InfoWrapper />
        <SiteMap />
        <ButtonArea>
          <Button onClick={() => window.scrollTo(0, 0)}>
            <Txt>TOP</Txt>
          </Button>
        </ButtonArea>
      </FooterContent>
    </FooterWrapper>
  );
};

export default Footer;
